module.exports = __webpack_public_path__ + "assets1733911544048/img/error-404.94756dcf.svg";